import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { onLoginGmail, onLoginUser, onRenew, onSendOtp } from './AuthThunk';
import { AuthLoginResult } from '../../../domain/entities/AuthLoginResult';

interface AuthState {
    isLoading: boolean;
    isRenewLoading: boolean;
    error?: string;
    login:boolean
}
  
const initialState: AuthState = {
    isLoading: false,
    isRenewLoading: false,
    error: undefined,
    login:false
};
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        onLogoutUser: ( _ ) => initialState,
    },
    extraReducers: (builder) => {
        builder
        .addCase(onRenew.pending, (state) => {
            state.isRenewLoading = true;
        })
        .addCase(onRenew.fulfilled, (state, action: PayloadAction<void>) => {
            state.isRenewLoading=false;
            state.login=true;
        })
        .addCase(onRenew.rejected, (state,action) => {
            state.error = action.error.message;
            state.isRenewLoading=false;
        })
        .addCase(onLoginUser.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(onLoginUser.fulfilled, (state, action: PayloadAction<AuthLoginResult>) => {
            state.isLoading=false;
            state.login=action.payload.kind === "authenticated";
        })
        .addCase(onLoginUser.rejected, (state,action) => {
            state.error = action.error.message;
            state.isLoading=false;
        })
        .addCase(onLoginGmail.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(onLoginGmail.fulfilled, (state, action: PayloadAction<AuthLoginResult>) => {
            state.isLoading=false;
            state.login=action.payload.kind === "authenticated";
        })
        .addCase(onLoginGmail.rejected, (state,action) => {
            state.error = action.error.message;
            state.isLoading=false;
        })
        .addCase(onSendOtp.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(onSendOtp.fulfilled, (state, action: PayloadAction<void>) => {
            state.isLoading=false;
        })
        .addCase(onSendOtp.rejected, (state,action) => {
            state.error = action.error.message;
            state.isLoading=false;
        })
    }
});
export const {onLogoutUser } = authSlice.actions;
export default authSlice.reducer;
